const doc = [({"en":({"js":({"admin":({"activity_participants":({"index":({"all_participants":"All participants"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;